module.exports = global["WebVTT"] = require("-!/Users/mkhazov/projects/wjplayer/node_modules/videojs-vtt.js/lib/index.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?WebVTT!./~/videojs-vtt.js/lib/index.js
 ** module id = 108
 ** module chunks = 0 1
 **/